var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 400,
    viewBox: "0 -90 500 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.73 99.99V254.52",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.14 148.65L452.26 74.6",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.14 148.65L4.25 94.05",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.14 148.65V303.18",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.62 142.48V297.13L189.14 303.18L168.66 297.13V142.67",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.78 80.36V234.89",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.38 127.37V158.95",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.85 119.88V152.9L267.38 158.95L246.9 152.9V132.82",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 78.48L189.14 133.07L452.26 59.02",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.21 106.17V248.47L24.73 254.52L4.25 248.47V78.48L267.38 4.42999L452.26 59.02V228.84L431.78 234.89L411.3 228.84V85.73",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.14 133.07V148.65",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 456.51,
    height: 307.61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStol);
export default __webpack_public_path__ + "static/media/stol.cdcc011ac7b8e3a5dcdfe7bd655b742d.svg";
export { ForwardRef as ReactComponent };